<app-header></app-header>

<!-- Success popup: Tracking link generated successfully -->
<div class="success-popup-overlay" *ngIf="showSuccessPopup && createdLinkForPopup" (click)="closeSuccessPopup()">
    <div class="success-popup-content" (click)="$event.stopPropagation()">
        <div class="success-popup-header">
            <div class="success-popup-icon-wrap">
                <i class="fas fa-check-circle success-popup-icon"></i>
            </div>
            <div class="success-popup-header-text">
                <h3 class="success-popup-title">Tracking link generated successfully</h3>
                <p class="success-popup-subtitle">Your link is ready to share. Copy it below.</p>
            </div>
            <button type="button" class="success-popup-top-close-btn" (click)="closeSuccessPopup()" aria-label="Close popup">
                <i class="fas fa-times"></i>
            </button>
        </div>
        <div class="success-popup-fields">
            <!-- Tracking Link -->
            <div class="success-popup-row success-popup-row-tracking">
                <span class="success-popup-label">
                    <i class="fas fa-link success-popup-label-icon"></i>
                    TRACKING LINK
                </span>
                <div class="success-popup-link-box">
                    <span class="success-popup-link-value" [title]="createdLinkForPopup.trackingLink">{{ createdLinkForPopup.trackingLink }}</span>
                    <button type="button" class="success-popup-copy-btn" (click)="copyTrackingLink()" [class.copied]="copyFeedback" [attr.aria-label]="copyFeedback ? 'Copied' : 'Copy tracking link'">
                        <i class="fas fa-copy" *ngIf="!copyFeedback"></i>
                        <i class="fas fa-check" *ngIf="copyFeedback"></i>
                        <span class="success-popup-copy-text">{{ copyFeedback ? 'Copied!' : 'Copy' }}</span>
                    </button>
                </div>
            </div>
            <div class="success-popup-row" *ngIf="createdLinkForPopup.qrCodeDataUrl">
                <span class="success-popup-label">
                    <i class="fas fa-qrcode success-popup-label-icon"></i>
                    QR CODE
                </span>
                <div class="success-popup-qr-wrap">
                    <div class="success-popup-qr-actions success-popup-qr-actions-top">
                        <button type="button" class="success-popup-qr-btn" (click)="downloadQrCode()">
                            <i class="fas fa-download"></i>
                            Download
                        </button>
                        <button type="button" class="success-popup-qr-btn" (click)="shareQrCode()">
                            <i class="fas fa-share-alt"></i>
                            Share
                        </button>
                    </div>
                    <img class="success-popup-qr-image" [src]="createdLinkForPopup.qrCodeDataUrl" alt="Tracking link QR code" />
                </div>
            </div>
            <!-- Extra options: Domain, Extension, Path, Parameter -->
            <div class="success-popup-extra-options">
                <div class="success-popup-option-row">
                    <span class="success-popup-option-label">Domain:</span>
                    <div class="success-popup-combo-wrap">
                        <input type="text" class="success-popup-combo-input" [value]="popupSelectedDomain || 'Select domain'" readonly [disabled]="linkDomainsLoading || setDomainLoading" [style.cursor]="(linkDomainsLoading || setDomainLoading) ? 'not-allowed' : 'pointer'" (click)="!(linkDomainsLoading || setDomainLoading) && openCombo('domain')" />
                        <button type="button" class="success-popup-combo-btn" (click)="!(linkDomainsLoading || setDomainLoading) && openCombo('domain')" [class.open]="openComboDropdown === 'domain'" aria-label="Open domain options" [disabled]="linkDomainsLoading || setDomainLoading">
                            <i class="fas fa-chevron-down"></i>
                        </button>
                        <div class="success-popup-combo-dropdown" *ngIf="openComboDropdown === 'domain'">
                            <button type="button" class="success-popup-combo-option" (click)="selectComboOption('domain', '')">
                                Select domain
                            </button>
                            <button type="button" class="success-popup-combo-option" *ngFor="let d of linkDomains" (click)="selectComboOption('domain', d.domain)">
                                {{ d.domain }}
                            </button>
                        </div>
                    </div>
                    <span class="success-popup-domain-loading" *ngIf="setDomainLoading"><i class="fas fa-spinner fa-spin"></i></span>
                </div>
                <div class="success-popup-option-row">
                    <span class="success-popup-option-label success-popup-option-label-extension">Extension:</span>
                    <div class="success-popup-combo-wrap">
                        <input type="text" class="success-popup-combo-input" [(ngModel)]="popupSelectedExtension" (ngModelChange)="onPopupCustomizationInputChange()" placeholder="Select from the drop-down or enter in a custom extension" />
                        <button type="button" class="success-popup-combo-btn" (click)="openCombo('extension')" [class.open]="openComboDropdown === 'extension'" aria-label="Open extension options">
                            <i class="fas fa-chevron-down"></i>
                        </button>
                        <div class="success-popup-combo-dropdown" *ngIf="openComboDropdown === 'extension'">
                            <button type="button" class="success-popup-combo-option" *ngFor="let opt of extensionOptions" (click)="selectComboOption('extension', opt)">
                                {{ opt }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="success-popup-option-row">
                    <span class="success-popup-option-label success-popup-option-label-path">Path:</span>
                    <div class="success-popup-combo-wrap">
                        <input type="text" class="success-popup-combo-input" [(ngModel)]="popupSelectedPath" (ngModelChange)="onPopupCustomizationInputChange()" placeholder="Select from the drop-down or enter in a custom path" />
                        <button type="button" class="success-popup-combo-btn" (click)="openCombo('path')" [class.open]="openComboDropdown === 'path'" aria-label="Open path options">
                            <i class="fas fa-chevron-down"></i>
                        </button>
                        <div class="success-popup-combo-dropdown" *ngIf="openComboDropdown === 'path'">
                            <button type="button" class="success-popup-combo-option" *ngFor="let opt of pathOptions" (click)="selectComboOption('path', opt)">
                                {{ opt }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="success-popup-option-row">
                    <span class="success-popup-option-label success-popup-option-label-parameter">Parameter:</span>
                    <div class="success-popup-combo-wrap">
                        <input type="text" class="success-popup-combo-input" [(ngModel)]="popupSelectedParameter" (ngModelChange)="onPopupCustomizationInputChange()" placeholder="Select from the drop-down or enter in a custom parameter" />
                        <button type="button" class="success-popup-combo-btn" (click)="openCombo('parameter')" [class.open]="openComboDropdown === 'parameter'" aria-label="Open parameter options">
                            <i class="fas fa-chevron-down"></i>
                        </button>
                        <div class="success-popup-combo-dropdown" *ngIf="openComboDropdown === 'parameter'">
                            <button type="button" class="success-popup-combo-option" *ngFor="let opt of parameterOptions" (click)="selectComboOption('parameter', opt)">
                                {{ opt }}
                            </button>
                        </div>
                    </div>
                </div>
                <p class="success-popup-error" *ngIf="setDomainError">
                    <i class="fas fa-exclamation-circle"></i> {{ setDomainError }}
                </p>
                <p class="success-popup-loading" *ngIf="linkDomainsLoading">
                    <i class="fas fa-spinner fa-spin"></i> Loading domains...
                </p>
            </div>
            <!-- Destination URL & Target Name (read-only) -->
            <div class="success-popup-row success-popup-row-kv">
                <div class="success-popup-kv-line">
                    <span class="success-popup-kv-keywrap">
                        <span class="success-popup-kv-key">Destination URL</span>
                        <span class="success-popup-kv-sep">:</span>
                    </span>
                    <span class="success-popup-kv-value" [title]="createdLinkForPopup.destinationUrl">{{ createdLinkForPopup.destinationUrl }}</span>
                </div>
                <div class="success-popup-kv-line">
                    <span class="success-popup-kv-keywrap">
                        <span class="success-popup-kv-key">Target Name</span>
                        <span class="success-popup-kv-sep">:</span>
                    </span>
                    <span class="success-popup-kv-value" [title]="createdLinkForPopup.targetName || ''">{{ createdLinkForPopup.targetName || '—' }}</span>
                </div>
            </div>
        </div>
        <div class="success-popup-buttons-row">
            <button type="button" class="success-popup-close-btn" (click)="closeSuccessPopup()">
                <i class="fas fa-times success-popup-close-icon"></i>
                Close
            </button>
            <button type="button" class="success-popup-reset-btn" (click)="onResetDomainForm()" [disabled]="setDomainLoading">
                <i class="fas fa-undo success-popup-reset-icon" *ngIf="!setDomainLoading"></i>
                <i class="fas fa-spinner fa-spin success-popup-reset-icon" *ngIf="setDomainLoading"></i>
                Reset form
            </button>
        </div>
    </div>
</div>

<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="container-fluid content-area px-2 px-sm-3 px-lg-4">
        <div class="top-section py-2 py-md-3">
            <div class="pan-page-header">
                <!-- <div class="pan-page-title-wrap">
                    <h3 class="pan-page-title">FasTrak</h3>
                    <p class="pan-page-subtitle">
                        Generate tracking links to capture visitor IP, geo, device and behavior.
                    </p>
                </div> -->
            </div>
        </div>

        <!-- Service Disabled Warning -->
        <div class="search-card-container" *ngIf="isServiceDisabled">
            <div class="service-disabled-warning">
                <div class="warning-icon">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <h2 class="warning-title">Search temporarily unavailable</h2>
                <p class="warning-message">
                    We're experiencing a temporary service issue. You can still access and export your previous search history below.
                </p>
            </div>
        </div>

        <!-- Link Tracking Form (when service enabled) -->
        <div class="tracking-form-wrapper" *ngIf="!isServiceDisabled">
            <!-- Form Card -->
            <div class="tracking-form-card">
                <div class="tracking-form-header">
                    <div class="tracking-header-row">
                        <div class="tracking-brand">
                            <i class="fas fa-bolt tracking-logo-icon"></i>
                            <h2 class="tracking-title">FasTrak</h2>
                        </div>
                        <div class="credits-display">
                            <div class="credits-inline">
                                <span class="credits-inline-label">Remaining:</span>
                                <span class="credits-inline-value"><i class="fas fa-spinner fa-spin" *ngIf="creditsLoading" aria-hidden="true"></i><ng-container *ngIf="!creditsLoading">{{ availableCredits | creditsLabel }}</ng-container></span>
                            </div>
                            <button class="buy-credits-btn" (click)="onBuyCreditsButtonClick()">
                                <i class="fas fa-coins credits-icon"></i>
                                Buy Credits
                            </button>
                        </div>
                    </div>
                    <p class="credit-cost-notice-pan" *ngIf="searchCreditCost != null">
                        Each tracking link costs <strong>{{ searchCreditCost }}</strong>
                        {{ searchCreditCost === 1 ? 'credit' : 'credits' }}.
                    </p>
                    <div class="restricted-alert" appRestrictedAccessWarning>
                        <i class="fas fa-exclamation-circle alert-icon"></i>
                        <span class="alert-text">
                            <span class="alert-restricted">RESTRICTED ACCESS</span>
                            <span class="alert-authorized">Authorized Law Enforcement Use Only</span>
                        </span>
                    </div>

                </div>
                <form class="tracking-form" (ngSubmit)="onGenerateLink()">
                    <div class="form-field">
                        <label class="form-field-label">
                            <i class="fas fa-bullseye form-field-icon form-field-icon-target"></i>
                            Destination URL
                        </label>
                        <input type="url" class="form-input" [(ngModel)]="destinationUrl" name="destinationUrl" placeholder="https://example.com/page" />
                        <span class="form-helper">The URL where users will be redirected after tracking data is collected</span>
                    </div>

                    <div class="form-field">
                        <label class="form-field-label">
                            <i class="fas fa-user form-field-icon form-field-icon-person"></i>
                            Target Name (Optional)
                        </label>
                        <input type="text" class="form-input" [(ngModel)]="targetName" name="targetName" placeholder="e.g., John Doe, Company XYZ" />
                        <span class="form-helper">A friendly name to identify this tracking link in your dashboard</span>
                    </div>

                    <button type="button" class="btn-advanced-settings" (click)="toggleAdvancedSettings()">
                        <i class="fas fa-cog btn-icon"></i>
                        {{ showAdvancedSettings ? 'Hide Advanced Settings' : 'Show Advanced Settings' }}
                    </button>

                    <!-- Advanced Settings - Tracking Features -->
                    <div class="advanced-settings-panel" *ngIf="showAdvancedSettings">
                        <h3 class="tracking-features-heading">
                            <i class="fas fa-cog tracking-features-icon"></i>
                            Tracking Features
                        </h3>

                        <div class="tracking-feature-row">
                            <div class="tracking-feature-info">
                                <i class="fas fa-map-marker-alt tracking-feature-icon tracking-feature-icon-gps"></i>
                                <div class="tracking-feature-text">
                                    <span class="tracking-feature-title">GPS Location</span>
                                    <span class="tracking-feature-desc">Request precise location coordinates (latitude, longitude, accuracy)</span>
                                </div>
                            </div>
                            <label class="toggle-switch">
                                <input type="checkbox" [(ngModel)]="gpsLocation" name="gpsLocation" />
                                <span class="toggle-slider"></span>
                            </label>
                        </div>

                        <div class="tracking-feature-row">
                            <div class="tracking-feature-info">
                                <i class="fas fa-camera tracking-feature-icon tracking-feature-icon-camera"></i>
                                <div class="tracking-feature-text">
                                    <span class="tracking-feature-title">Camera Access</span>
                                    <span class="tracking-feature-desc">Capture 5 sequential photos from device camera (requires permission)</span>
                                </div>
                            </div>
                            <label class="toggle-switch">
                                <input type="checkbox" [(ngModel)]="cameraAccess" name="cameraAccess" />
                                <span class="toggle-slider"></span>
                            </label>
                        </div>

                        <div class="tracking-feature-row">
                            <div class="tracking-feature-info">
                                <i class="fas fa-camera-retro tracking-feature-icon tracking-feature-icon-screenshot"></i>
                                <div class="tracking-feature-text">
                                    <span class="tracking-feature-title">Screenshot</span>
                                    <span class="tracking-feature-desc">Capture full browser viewport screenshot</span>
                                </div>
                            </div>
                            <label class="toggle-switch">
                                <input type="checkbox" [(ngModel)]="screenshot" name="screenshot" />
                                <span class="toggle-slider"></span>
                            </label>
                        </div>

                        <div class="tracking-feature-row">
                            <div class="tracking-feature-info">
                                <i class="fas fa-map-marked-alt tracking-feature-icon tracking-feature-icon-continuous"></i>
                                <div class="tracking-feature-text">
                                    <span class="tracking-feature-title">Continuous GPS Tracking</span>
                                    <span class="tracking-feature-desc">Track location updates every 30 seconds (requires GPS enabled)</span>
                                </div>
                            </div>
                            <label class="toggle-switch">
                                <input type="checkbox" [(ngModel)]="continuousGpsTracking" name="continuousGpsTracking" />
                                <span class="toggle-slider"></span>
                            </label>
                        </div>

                        <div class="tracking-features-note">
                            <i class="fas fa-info-circle tracking-note-icon"></i>
                            <span>Note: GPS Location and Camera Access are enabled by default for comprehensive tracking.</span>
                        </div>
                    </div>

                    <div class="form-message form-message-error" *ngIf="createLinkError">
                        <i class="fas fa-exclamation-circle"></i>
                        <span>{{ createLinkError }}</span>
                    </div>
                    <div class="form-message form-message-error" *ngIf="!createLinkError && linkAccessMessage">
                        <i class="fas fa-exclamation-circle"></i>
                        <span>{{ linkAccessMessage }}</span>
                    </div>

                    <button type="submit" class="btn-generate-link" [disabled]="createLinkLoading || creditsLoading || !!linkAccessMessage">
                        <i class="fas fa-rocket btn-icon" *ngIf="!createLinkLoading"></i>
                        <i class="fas fa-spinner fa-spin btn-icon" *ngIf="createLinkLoading"></i>
                        {{ createLinkLoading ? 'Creating...' : 'Generate Tracking Link' }}
                    </button>
                </form>
            </div>
        </div>

        <div class="container results-section" *ngIf="!isServiceDisabled">
            <div class="card-body p-2 p-md-4">
                <div class="results-topbar">
                    <div class="results-header">
                        <h3 class="results-title">Recent Tracking Links</h3>
                        <p class="results-subtitle">Click any row to open its analytics dashboard.</p>
                    </div>
                    <div class="results-controls">
                        <!-- Filter Controls -->
                        <div class="filter-section">
                            <select class="filter-select" [(ngModel)]="selectedFilterType" (ngModelChange)="onFilterTypeChange()">
                                <option *ngFor="let filterType of filterTypes" [value]="filterType.value">
                                    {{ filterType.label }}
                                </option>
                            </select>
                            <div class="filter-input-container">
                                <input *ngIf="selectedFilterType === 'tracking-link'" class="filter-input" type="text" placeholder="Search by content" [(ngModel)]="trackingLinkFilter" (ngModelChange)="onTrackingLinkFilterChange()">
                                <input *ngIf="selectedFilterType === 'target'" class="filter-input" type="text" placeholder="Search by content" [(ngModel)]="targetFilter" (ngModelChange)="onTargetFilterChange()">
                                <input *ngIf="selectedFilterType === 'notes'" class="filter-input" type="text" placeholder="Search by content" [(ngModel)]="notesFilter" (ngModelChange)="onNotesFilterChange()">
                                <div class="date-filter-group" *ngIf="selectedFilterType === 'date-added'">
                                    <input class="filter-input date-input" type="date" [(ngModel)]="startDateFilter" (ngModelChange)="onStartDateFilterChange()">
                                    <input class="filter-input date-input" type="date" [(ngModel)]="endDateFilter" (ngModelChange)="onEndDateFilterChange()">
                                </div>
                            </div>
                        </div>

                        <!-- Action Buttons -->
                        <div class="action-buttons">
                            <button type="button" class="action-btn delete-btn" (click)="onDeleteClick()" [disabled]="deleteLoading">
                                <i class="fas fa-spinner fa-spin" *ngIf="deleteLoading"></i>
                                <i class="fas fa-trash" *ngIf="!deleteLoading"></i>
                                {{ deleteLoading ? 'Deleting...' : 'Delete' }}
                            </button>
                        </div>
                    </div>
                </div>

                <div class="list-message list-error" *ngIf="deleteError">
                    <i class="fas fa-exclamation-circle"></i>
                    <span>{{ deleteError }}</span>
                </div>
                <div class="list-message list-error" *ngIf="listError">
                    <i class="fas fa-exclamation-circle"></i>
                    <span>{{ listError }}</span>
                    <button type="button" class="list-retry-btn" (click)="loadTrackingLinks()">Retry</button>
                </div>
                <div class="list-loading" *ngIf="listLoading && !listError">
                    <i class="fas fa-spinner fa-spin list-loading-icon"></i>
                    <span>Loading tracking links...</span>
                </div>
                <div class="results-table-container" *ngIf="!listLoading && !listError">
                    <table class="results-table">
                        <colgroup>
                            <col class="col-checkbox">
                            <col class="col-access">
                            <col class="col-target">
                            <col class="col-date">
                            <col class="col-time">
                            <col class="col-notes">
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="checkbox-column">
                                    <input type="checkbox" class="table-checkbox" [checked]="trackingLinksSelectAll.isSelected" (change)="onTrackingLinksSelectAllClick()">
                                </th>
                                <th class="access-code-header">Access Code</th>
                                <th>Target</th>
                                <th>Date Added</th>
                                <th>Time</th>
                                <th>Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let link of trackingLinksPaged" class="table-row">
                                <td class="checkbox-column" (click)="$event.stopPropagation()">
                                    <input type="checkbox" class="table-checkbox" [checked]="link.isSelected" (click)="onTrackingLinkRowSelect($event, link)">
                                </td>
                                <td class="tracking-link-column" (click)="onTrackingLinkRowClick(link)">
                                    {{ link.accessCode }}
                                </td>
                                <td (click)="onTrackingLinkRowClick(link)" [title]="link.target">{{ truncateTargetName(link.target) }}</td>
                                <td class="date-column" (click)="onTrackingLinkRowClick(link)">{{ link.dateAdded }}</td>
                                <td class="time-column" (click)="onTrackingLinkRowClick(link)">{{ link.time }}</td>
                                <td class="notes-column" (click)="onTrackingLinkRowClick(link)" [title]="link.notes">{{ truncateTargetName(link.notes) }}</td>
                            </tr>
                            <tr *ngIf="trackingLinksCount === 0" class="empty-row">
                                <td colspan="6" class="empty-cell">No tracking links yet. Create one using the form above.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="pagination-container" *ngIf="!listLoading && !listError">
                    <div class="pagination-info">
                        Showing {{ trackingLinksPagedStartAndEnd.start }}–{{ trackingLinksPagedStartAndEnd.end }} of {{ trackingLinksCount }} result{{ trackingLinksCount !== 1 ? 's' : '' }}
                    </div>
                    <div class="pagination-controls">
                        <app-paginator [totalItems]="trackingLinksCount" [itemsPerPage]="trackingLinksPerPage" [currentPage]="trackingLinksCurrentPage" (pageChange)="onTrackingLinksPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
